import * as ActionTypes from 'actions/managePermissions'

const initialState = {
  isFetching: false,
  adminUsers: [],
  roles: [],
}

export default function mdm(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.MANAGE_PERMISSIONS_GETING_ADMIN_USERS:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.MANAGE_PERMISSIONS_RECEIVED_ADMIN_USERS:
      return {
        ...state,
        isFetching: false,
        // fetched: true,
        adminUsers: action.adminUsers,
      }
    case ActionTypes.MANAGE_PERMISSIONS_GETING_ROLES:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.MANAGE_PERMISSIONS_RECEIVED_ROLES:
      return {
        ...state,
        isFetching: false,
        // fetched: true,
        roles: action.roles,
      }
    case ActionTypes.MANAGE_PERMISSIONS_SAVE_USER_START:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.MANAGE_PERMISSIONS_SAVE_USER_COMPLETE:
      return {
        ...state,
        isFetching: false,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/managePermissions.js